import { ref } from 'vue'
import createDocumentStore from '@/frontapp/store/bcDocument'

/*
const routesDocument = [
  'BCDocument', 
  'BCDocumentDetail', 
  'BCDocumentDetailRev',
  'BCSharedDocument'
]
*/

const documentStores = new Map() // storeId => useStore function
const frozenDocumentStores = new Map() // storeInstanceId => storeId
documentStores.set('document0', createDocumentStore())
const activeBcDocumentStoreId = ref('document0')

const useDocumentStore = (storeId) => {
  return documentStores.get(storeId)()
}

const useActiveDocumentStore = () => {
  return useDocumentStore(activeBcDocumentStoreId.value)
}

const getStoreInstanceId = (id, revId = undefined, shared = false) => (revId ? id + '-' + revId : id.toString()) + (shared ? '-share' : '')

const getActiveStoreInstanceIds = () => {
  const activeStore = useActiveDocumentStore()

  if (!activeStore.document?.id) {
    return { woRev: null, wRev: null, full: null }
  }

  const woRev = getStoreInstanceId(activeStore.document.id, undefined, activeStore.isShared)
  const full = getStoreInstanceId(activeStore.document.id, activeStore.documentRev, activeStore.isShared)
  const wRev = activeStore.documentRev ? full : null

  return { woRev, wRev, full }
}

// save current instance to document stores under keys
// documentId + shared
// documentId + revId
const freezeActiveDocumentStore = () => {
  const activeStore = activeBcDocumentStoreId.value
  const activeStoreInstanceIds = getActiveStoreInstanceIds()
  console.log('freezeActiveDocumentStore', activeStoreInstanceIds)
  frozenDocumentStores.set(activeStoreInstanceIds.woRev, activeStore)
  if (activeStoreInstanceIds.wRev) {
    frozenDocumentStores.set(activeStoreInstanceIds.wRev, activeStore)
  }
  return activeStore
}

// check if frozen document store exists for document
const isDocumentStoreFrozen = (documentId, revId = undefined, shared = false) => {
  if (frozenDocumentStores.has(getStoreInstanceId(documentId, revId, shared))) {
    return frozenDocumentStores.get(getStoreInstanceId(documentId, revId, shared))
  }

  return false
}

// activate frozen instance of document store if exists
const activateDocumentStore = (documentId, revId = undefined, shared = false) => {
  const activeStoreInstanceIds = getActiveStoreInstanceIds()
  const newStoreInstanceId = getStoreInstanceId(documentId, revId, shared)

  // active store is same
  if (activeStoreInstanceIds.full === newStoreInstanceId) {
    return useActiveDocumentStore()
  }

  // new store is frozen?
  const frozenDocumentStore = isDocumentStoreFrozen(documentId, revId, shared)
  if (frozenDocumentStore) {
    activeBcDocumentStoreId.value = frozenDocumentStore
    return useActiveDocumentStore()
  }

  // currently active store is in frozen state
  // create new store instace
  if (frozenDocumentStores.has(activeStoreInstanceIds.full)) {
    const useNewStore = createDocumentStore()
    const newStoreInstance = useNewStore()
    const storeId = newStoreInstance.currentBcDocumentStoreId
    documentStores.set(storeId, useNewStore)
    activeBcDocumentStoreId.value = storeId
    return newStoreInstance
  }

  // otherwise use current active store
  return useActiveDocumentStore()
}

// when frozen document change revision -> update keys in documentStores map
const updateFrozenDocumentStoreRevId = (documentId, fromRevId, toRevId) => {
  const frozenStore = isDocumentStoreFrozen(documentId, fromRevId, false)
  if (frozenStore) {
    const frozenStoreId = getStoreInstanceId(documentId, fromRevId)
    frozenDocumentStores.set(getStoreInstanceId(documentId, toRevId), frozenStore)
    frozenDocumentStores.delete(frozenStoreId)
  }
}

// change store to not frozen state if is frozen
const unfreezeDocumentStore = (documentId, revId, shared) => {
  if (isDocumentStoreFrozen(documentId, revId, shared)) {
    const frozenDocumentStoreId = getStoreInstanceId(documentId, revId, shared)
    console.log('unfreezeDocumentStore', frozenDocumentStoreId)
    frozenDocumentStores.delete(frozenDocumentStoreId)
  }

  const frozenDocumentStoreWithoutRevId = isDocumentStoreFrozen(documentId, undefined, shared)
  if (frozenDocumentStoreWithoutRevId) {
    if (documentStores.get(frozenDocumentStoreWithoutRevId)().documentRev == revId) {
      const frozenDocumentStoreId = getStoreInstanceId(documentId, undefined, shared)
      console.log('unfreezeDocumentStore', frozenDocumentStoreId)
      frozenDocumentStores.delete(frozenDocumentStoreId)
    }
  }
}

export {
  isDocumentStoreFrozen,
  freezeActiveDocumentStore,
  updateFrozenDocumentStoreRevId,
  activateDocumentStore,
  unfreezeDocumentStore,
  useDocumentStore,
  useActiveDocumentStore,
  activeBcDocumentStoreId
}

export default {
  computed: {
    bcDocumentStore() {
      return useActiveDocumentStore()
    }
  },
}
